module.exports = __webpack_public_path__ + "img/wmv.93d4fd26.svg";